{
	"backToManageDeclarations": "Retour à la gestion des déclarations",
	"kpi": {
		"quantity": "Quantité",
		"carbonSavings": "Réductions de carbone"
	},
	"downloadAllDeclarations": "Télécharger toutes les déclarations",
	"errors": {
		"notFound": "Projet introuvable"
	}
}
